/**
 * Extended ViewController template
 *
 * User: adic
 * Date: 3/28/13
 * Time: 2:45 PM
 */
define(function (require) {

    window.lpTag = window.lpTag || {};

    var WidgetsManagerViewController = require('web-agent-framework/WidgetsManagerViewController');
    var ViewController = require('web-agent-framework/ViewController');

    var WidgetViewController = ViewController.extend({
        ControllerName: 'WidgetViewController',

        LPViewMap: {},
        LPViewClasses: {
            button: "right_pane_button",
            widgetWrapper: "right_pane_widget_wrapper",
            widgetWrapperWithIFrame: "right_pane_widget_wrapper_iframe",
            widgetIdentifier: "lpview_widget",
            sdkNotifications: "sdk_notifications"
        },

        initialize: function (constructorData) {
            if (constructorData) {
                this.visitorId = constructorData.visitorId;
                this.widgetsManager = constructorData.widgetsManager;
                this.singleton = constructorData.singleton; // TODO: On singleton bind the focused visitor ID in update.
                this.myChatsOnly = constructorData.myChatsOnly || false;
            }

            if (!this.applicationType) {
                this.logger.error("Unable to initialize widget, missing applicationType", "initialize");
                return "Unable to initialize widget, missing applicationType";
            }

            if (this.iframe) {
//            this.view.innerHTML = "<iframe scrolling='yes' style='border: 0px; width: 100%; height: 100%; position: relative;'></iframe>";
//            this.iframeView = this.view.firstChild;
            }

            this.isFocused = false;
        },

        events: function () {
            this.bindModel({modelPath: "agent.status", callback: this.statusChanged});
            if (this.visitorId) {
                var visitorId = this.visitorId;
                this.visitorId = null;
                this.updateVisitorId(visitorId);
            }
        },

        render: function () {
            if (!this.widgetInitialized && this.widgetsManager) {
                var widgetWrapperClass = this.LPViewClasses.widgetWrapper;
                if (this.iframe) {
                    widgetWrapperClass = this.LPViewClasses.widgetWrapperWithIFrame;
                }
                this.addClass(this.view, [this.LPViewClasses.widgetIdentifier, widgetWrapperClass]);
                this.widgetsManager.addWidgetContent(this);

                // Setting initialized here since setting the icon and content should not update the manager since the addWidget here
                // updates the manager already.
                this.widgetInitialized = true;

                this.view.tabIndex = this.widgetsManager.getWidgetIndex(this.applicationType);
            }
        }
    });

    WidgetViewController.prototype.updateVisitorId = function (visitorId) {
        if (this.visitorId && !this.singleton) {
            this.unbindModel({
                modelPath: lpTag.WebAgent.logicController.getParticipantPath(this.visitorId) + '.chats',
                callback: this.onChatIdChanged
            });
            this.viewEventsHandler.unbindEvent({appName: this.visitorId, UIEvent: this.eventType.VISITOR_FOCUSED, callback: this.visitorFocused});
            this.viewEventsHandler.unbindEvent({appName: this.visitorId, UIEvent: this.eventType.VISITOR_BLURRED, callback: this.visitorBlurred});
            this.viewEventsHandler.unbindEvent({appName: this.visitorId, UIEvent: this.eventType.VISITOR_DISPOSED, callback: this.visitorDisposed});
        }

        this.visitorId = visitorId;
        if (this.visitorId && !this.singleton) {
            this.bindModel({
                modelPath: lpTag.WebAgent.logicController.getParticipantPath(this.visitorId) + '.chats',
                callback: this.onChatIdChanged
            });
            this.viewEventsHandler.bindEvent({appName: this.visitorId, UIEvent: this.eventType.VISITOR_FOCUSED, callback: this.visitorFocused});
            this.viewEventsHandler.bindEvent({appName: this.visitorId, UIEvent: this.eventType.VISITOR_BLURRED, callback: this.visitorBlurred});
            this.viewEventsHandler.bindEvent({appName: this.visitorId, UIEvent: this.eventType.VISITOR_DISPOSED, callback: this.visitorDisposed});
        }
    };

    WidgetViewController.prototype.onChatIdChanged = function (data) {
        // abstract implementation (optional)
    };

    WidgetViewController.prototype.addLine = function (text) {
        this.viewEventsHandler.fireEvent({
            appName: this.visitorId,
            UIEvent: this.viewEventsHandler.eventType.PRE_DEFINED_CONTENT_SELECTED, // TODO: Change the Pre Define fire
            eventData: {text: text}, deleteOnFire: true
        });
    };

    WidgetViewController.prototype.setIconURL = function (url) {
        var img;
        if (!this.icon) {
            img = document.createElement("img");
            this.addClass(img, this.LPViewClasses.button);
            img.style.width = "21px";
            img.style.height = "21px";
            this.setIconView(img);
        }

        img = this.getFirstElement('img', this.icon);
        if (img) {
            img.src = url;
        }
    };

    WidgetViewController.prototype.focusWidget = function (callback) {
        if (this.widgetsManager) {
            var that = this;
            this.widgetsManager.widgetSelected({lpEventData: this}, function () {
                that.view.focus();
                if (callback && typeof callback === 'function') {
                    callback.call(that);
                }
            });
        } else {
            this.lpShow();
            this.view.focus();
            if (callback && typeof callback === 'function') {
                callback();
            }
        }
    };

    WidgetViewController.prototype.setIconView = function (iconView) {
        if (!this.icon) {
            this.icon = document.createElement("div");
        }
        this.icon.innerHTML = "";
        this.addClass(this.icon, ["right_pane_button", "button", "grey"]);

        if (this.mode === 'test') {
            this.addClass(this.icon, ["right_pane_button", "button", "grey", "custom_widget_icon_pilot"]);
            this.removeClass(iconView, "custom_widget_icon_pilot");
        }
        this.icon.appendChild(iconView);

        this.addNotificationDivToCustomWidget(iconView);

        if (!this.prohibitTranslation) {
            this.icon.title = this.translate(this.applicationType) || this.applicationType;
        } else {
            this.icon.title = this.displayName || this.applicationType;
        }
        if (this.widgetInitialized) {
            this.widgetsManager.setIconView(this);
        }
    };

    WidgetViewController.prototype.addNotificationDivToCustomWidget = function (iconView) {
        if(this.hasSingleClass(iconView, "custom_widget_icon")) {
            var sdkNotificationsDiv = document.createElement("div");
            this.addClass(sdkNotificationsDiv, this.LPViewClasses.sdkNotifications);
            this.icon.appendChild(sdkNotificationsDiv);
        }
    };

    WidgetViewController.prototype.statusChanged = function (data) {
        if (typeof data.newValue !== 'undefined' && data.newValue !== 'loggedIn') {
            this.dispose();
        }
    };

    WidgetViewController.prototype.onShow = function (callbackFunc, context) { // TODO: Unregister?!
        if (!this.showListeners) {
            this.showListeners = [];
        }

        this.showListeners.push({context: context, callback: callbackFunc});
    };

    WidgetViewController.prototype.onHide = function (callbackFunc, context) { // TODO: Unregister?!
        if (!this.hideListeners) {
            this.hideListeners = [];
        }

        this.hideListeners.push({context: context, callback: callbackFunc});
    };

    WidgetViewController.prototype.onDispose = function (callbackFunc, context) { // TODO: Unregister?!
        if (!this.disposeListeners) {
            this.disposeListeners = [];
        }

        this.disposeListeners.push({context: context, callback: callbackFunc});
    };

    WidgetViewController.prototype.visitorDisposed = function () {
        this.notifyListeners(this.disposeListeners);
        this.disposeListeners = null;
        this.dispose();
    };

    WidgetViewController.prototype.visitorFocused = function () {
        this.isFocused = true;
        this.showWidget();
    };

    WidgetViewController.prototype.visitorBlurred = function () {
        this.isFocused = false;
        this.hideWidget();
    };

    /**
     * This method will show the widget when called
     */
    WidgetViewController.prototype.showWidget = function () {
        if (this.hidden || (this.myChatsOnly && lpTag.WebAgent.logicController.isSpectatedEngagement(this.visitorId))) {
            this.hideWidget();
        } else if (this.isFocused || this.singleton) {
            this.lpShow();
            this.notifyOnShow(); // TODO: Check if we want to notify on show when the widget is display=none
            if (this.widgetsManager) {
                this.widgetsManager.showWidgetContainer(this.applicationType);
            }
        }
    };

    WidgetViewController.prototype.hideWidget = function () {
        this.lpHide();
        this.notifyOnHide();
    };

    WidgetViewController.prototype.notifyOnShow = function () {
        this.widgetVisible = true;
        this.notifyListeners(this.showListeners);
    };

    WidgetViewController.prototype.notifyOnHide = function () {
        this.widgetVisible = false;
        this.notifyListeners(this.hideListeners);
    };

    WidgetViewController.prototype.notifyListeners = function (listenersList) {
        if (typeof listenersList === 'undefined' || listenersList === null || listenersList.constructor !== Array) {
            return;
        }

        var i;
        var length = listenersList.length;
        var context;
        var callback;
        for (i = 0; i < length; i++) {
            context = listenersList[i].context;
            callback = listenersList[i].callback;
            callback.call(context, this);
        }
    };


    return WidgetViewController;

});
